import { Cwb_PositionalAttribute } from "../../../../Shared/Shared.js";
import { ofArray } from "../../../../fable_modules/fable-library.3.7.9/List.js";

export const lemma = new Cwb_PositionalAttribute("lemma", "Lemma");

export const pos = new Cwb_PositionalAttribute("pos", "Part-of-speech");

export const gender = new Cwb_PositionalAttribute("gender", "Gender");

export const num = new Cwb_PositionalAttribute("num", "Number");

export const type = new Cwb_PositionalAttribute("type", "Type");

export const defn = new Cwb_PositionalAttribute("defn", "Definiteness");

export const temp = new Cwb_PositionalAttribute("temp", "Tense");

export const pers = new Cwb_PositionalAttribute("pers", "Person");

export const case$ = new Cwb_PositionalAttribute("case", "Case");

export const degr = new Cwb_PositionalAttribute("degr", "Degree");

export const mood = new Cwb_PositionalAttribute("mood", "Mood");

export const voice = new Cwb_PositionalAttribute("voice", "Voice");

export const descr = new Cwb_PositionalAttribute("descr", "Description");

export const nlex = new Cwb_PositionalAttribute("nlex", "Non-lexical");

export const list = ofArray([lemma, pos, gender, num, type, defn, temp, pers, case$, degr, mood, voice, descr, nlex]);

